import { connect } from "react-redux";
import { NotebookWrapper as Component } from "./NotebookWrapper";
import {
  setChapter,
  startTour,
  updateChapterProgress,
  updateNotebookProgress,
  updateMutatedChapterProgress,
  updateSceneData,
} from "@learningblocks/exp-redux";
import { setCollapse } from "@learningblocks/exp-redux";
import {
  getTitle,
  getSimType,
  getProgress,
  getMaxProgress,
  getCurrentProgress,
  getMenuList,
  getCurrentMenu,
  getDescription,
  getPreviousMenuValue,
  getNextMenuValue,
  getDrawerCollapsed,
  getCurrentChapterFromMenu,
} from "./NotebookWrapper.selector";

function mapStateToProps(state) {
  return {
    drawerCollapsed: getDrawerCollapsed(state),
    components: getCurrentChapterFromMenu(state),
    menuList: getMenuList(state),
    currentMenu: getCurrentMenu(state),
    prevMenuValue: getPreviousMenuValue(state),
    nextMenuValue: getNextMenuValue(state),
    title: getTitle(state),
    simType: getSimType(state),
    progress: getProgress(state),
    maxProgress: getMaxProgress(state),
    currentProgress: getCurrentProgress(state),
    description: getDescription(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSetChapter: (params) => {
      dispatch(setChapter(params));
    },
    onUpdateSceneData: (params) => {
      dispatch(updateSceneData(params));
    },
    onUpdateProgress: (params) => {
      const { overallProgress, ...menuParams } = params;
      dispatch(updateChapterProgress(menuParams));
      dispatch(updateNotebookProgress(overallProgress));
    },
    onMutatedUpdateProgress: (params) => {
      const { overallProgress, ...menuParams } = params;
      dispatch(updateMutatedChapterProgress(menuParams));
      dispatch(updateNotebookProgress(overallProgress));
    },
    onSetCollapse: (params) => {
      dispatch(setCollapse(params));
    },
    startTour: () => {
      dispatch(startTour());
    },
  };
}

export const NotebookWrapper = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
